import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {Box, TextField} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {IVatCode} from "../../../../utils/interfaces/my_documents/IVatCode";
import useApiGetVatCodes from "./api-hooks/useApiGetVatCodes";
import useApiGetVatCode from "./api-hooks/useApiGetVatCode";
import Loading from "../../../ui/Loading";
import MuiAutocomplete from "../../../ui/mui/mui-input/MuiAutoComplete";
import {useToast} from "../../../../utils/contexts/toast-context";


interface Props {
    obj: IVatCode | undefined,
    onChange: (obj: IVatCode | undefined) => void,
    className: string,
    label?: string,
    required?: boolean
    clearable?: boolean
    isDisabled?: boolean
}

const VatCodeSelect = ({
                           obj: initialObj,
                           label,
                           onChange,
                           required,
                           clearable,
                           isDisabled,
                       }: Props) => {

    const {displayError} = useToast()
    const theme = useTheme();
    const {t} = useTranslation()

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [isEditFormOpen, setIsEditFormOpen] = useState<boolean>(false)
    const [isListTableOpen, setIsListTableOpen] = useState<boolean>(false)


    const [objs, setObjs] = useState<IVatCode[]>([]);
    const [obj, setObj] = useState<IVatCode | undefined>(initialObj)


    useEffect(() => {
        setObj(undefined);
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj]);


    const {
        data,
        isLoading,
        error,
    } = useApiGetVatCodes();


    useEffect(() => {
        if (data) {
            setObjs(data)
        }
    }, [data]);


    const {
        data: detailedObj,
    } = useApiGetVatCode(obj?.id);

    useEffect(() => {
        if (detailedObj) {
            setObj(detailedObj);
        } else {
            setObj(undefined);
        }
    }, [detailedObj]);

    const handleOnChange = (event: React.SyntheticEvent, newValue: IVatCode | null) => {
        if (newValue) {
            onChange(newValue);
        } else {
            onChange(undefined);
        }
    };

    useEffect(() => {
        onChange(obj);
    }, [obj]);


    return (
        <>
            {isLoading ? (
                <Loading/>
            ) : (
                <>
                    <Box sx={{alignItems: 'center', width: '100%'}}>
                        <MuiAutocomplete
                            disableClearable={!clearable}
                            id="vat_code-select"
                            options={objs}
                            getOptionLabel={(option: IVatCode) => option.fe_natura + ' - ' + option.description}
                            value={detailedObj ? detailedObj : null}
                            onChange={handleOnChange}
                            isDisabled={isDisabled}
                            isOptionEqualToValue={(option, value) => option.id === value?.id && option.description === value?.description}
                            renderInput={(params: any) => (
                                <TextField
                                    sx={{textTransform: 'capitalize'}}
                                    {...params}
                                    label={label ? t(label) : '' || t('vat_code')}
                                    required={required}
                                />
                            )}
                            borderColor={theme.palette.primary.light}
                            onFocusBorderColor={theme.palette.primary.dark}
                            minWidth={300}
                        >
                        </MuiAutocomplete>
                    </Box>
                </>
            )}
        </>
    );
}

export default VatCodeSelect;